module.exports = __webpack_public_path__ + "static/img/code-aside.5f79621.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/code-aside.png
// module id = KWaO
// module chunks = 0